import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

export namespace UpdateMfaStatusEnroll {
  export type Input = void;
  export type Output = {
    enrollmentTicketUrl: string;
  };

  export function useMutation() {
    const updateMfaEnroll = useInjectFeApiContext(FeApi.usersV1MfaEnrollCreate);
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(): Promise<Output> {
        const result = await ok(updateMfaEnroll({}));
        return { enrollmentTicketUrl: result.enrollment_ticket_url };
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['me'],
        });
      },
    });
  }
}
